import { AuthUserPermission, usePermissions, useUser, useWindowTitle } from '@cibo/profile'
import { FullScreenError, Tabs, useParamAsInteger } from '@cibo/ui'
import { Box, Stack, Tab } from '@mui/material'
import { StatusCodes } from 'http-status-codes'
import { ADMIN_ROUTES } from 'navigation/types'
import { useTranslation } from 'react-i18next'
import { Link, Navigate, Outlet, generatePath, useLocation } from 'react-router-dom'

export const UserNavigation = () => {
  const { t } = useTranslation('impact/UserProfile')
  useWindowTitle(t('pageTitle'))
  const userId = useParamAsInteger('userId')
  const { pathname } = useLocation()
  const { can } = usePermissions()
  const orgUserId = userId

  const { data: loggedInUser } = useUser()
  const paths = pathname.split('/')
  const tabValue = paths[4]
  const isCurrentUser = loggedInUser?.user.userId === userId

  if (!orgUserId) {
    return <FullScreenError status={StatusCodes.NOT_FOUND} />
  }

  if (!isCurrentUser && tabValue === 'preferences') {
    return (
      <Navigate
        replace
        to={generatePath(ADMIN_ROUTES.USER_PROFILE, { userId: userId.toString() })}
      />
    )
  }
  return (
    <Stack flex={1}>
      <Box py={2}>
        <Tabs value={tabValue || 'programActivity'} variant="scrollable" scrollButtons="auto">
          <Tab
            component={Link}
            to={generatePath(ADMIN_ROUTES.USER_PROGRAMS, { userId: userId.toString() })}
            label={t('programActivity')}
            data-testid="user-programActivity"
            value="programActivity"
          />
          <Tab
            component={Link}
            to={generatePath(ADMIN_ROUTES.USER_FIELDS, { userId: userId.toString() })}
            label={t('fields')}
            data-testid="user-fields"
            value="fields"
          />
          {can({ useAny: AuthUserPermission.AGREEMENTS }) && (
            <Tab
              component={Link}
              to={generatePath(ADMIN_ROUTES.USER_AGREEMENTS, { userId: userId.toString() })}
              label={t('agreements')}
              data-testid="user-agreements"
              value="agreements"
            />
          )}
          <Tab
            component={Link}
            to={generatePath(ADMIN_ROUTES.USER_PROFILE, { userId: userId.toString() })}
            label={t('profile')}
            data-testid="user-profile"
            value="profile"
          />
          {isCurrentUser && (
            <Tab
              component={Link}
              to={generatePath(ADMIN_ROUTES.USER_PREFERENCES, { userId: userId.toString() })}
              label={t('preferences')}
              data-testid="user-preferences"
              value="preferences"
            />
          )}
        </Tabs>
      </Box>

      <Stack flex={1} p={2} sx={{ backgroundColor: 'background.paper' }}>
        <Outlet />
      </Stack>
    </Stack>
  )
}
